import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './Layout';
import { stackRoutes } from './stack.routes';
import { LoggedInLayout } from '../components/layout/loggedInLayout';
import ProtectedRoute from './protected-route.route';
import { customerProtectedRoutes } from './customer-protected.routes';
import { commonProtectedRoutes } from './common-protected.routes';
import { adminProtectedRoutes } from './admin-protected.routes';

export const Router = () => {
    const router = createBrowserRouter([
        {
            element: <Layout />,
            children: stackRoutes,
        },
        {
            element: <ProtectedRoute />, // Check authentication before rendering
            children: [
                {
                    element: <LoggedInLayout />, // Keep existing layout
                    children: commonProtectedRoutes,
                },
            ],
        },
        {
            element: <ProtectedRoute requiredRole='customer' />, // Check authentication before rendering
            children: [
                {
                    element: <LoggedInLayout />, // Keep existing layout
                    children: customerProtectedRoutes,
                },
            ],
        },
        {
            element: <ProtectedRoute requiredRole='admin' />, // Check authentication before rendering
            children: [
                {
                    element: <LoggedInLayout />, // Keep existing layout
                    children: adminProtectedRoutes,
                },
            ],
        }
    ]);

    return { router };
};